// Protocolo do Hábito — a permissão de abandonar.
//
// "Oferecida ativamente por volta da página 50, enquadrada como decisão de
// curadoria e não como desistência. O comportamento rastreado deve ser LER, não
// terminar este livro — abandonar não pode quebrar sequência."
//
// A taxa de conclusão é uma função do livro, não do leitor: um thriller
// comercial é terminado por 83% das pessoas, um vencedor do Pulitzer por 44% e
// uma não-ficção "importante" por 28%. Insistir num livro errado é o jeito mais
// comum de perder o hábito inteiro.

import React, { useState } from 'react';
import { Sheet, BookCover } from '../common';
import { Icon } from '../icons';
import { AuthSession, BookV2 } from '../../types';
import { habitoApi } from './api';

const serif = 'Instrument Serif, Georgia, serif';

export const TrocarLivro: React.FC<{
  open: boolean;
  session: AuthSession | null;
  interesse: string | null;
  livroAtual: { id: string; titulo: string } | null;
  meusLivros: BookV2[];
  onFechar: () => void;
  onTrocado: () => void;
  /** Abre a folha de adicionar livro. Sem isto, quem só tem o livro atual
   *  fica sem saída nenhuma dentro desta tela. */
  onAdicionarLivro?: () => void;
}> = ({ open, session, livroAtual, meusLivros, onFechar, onTrocado, onAdicionarLivro }) => {
  const [salvando, setSalvando] = useState(false);

  async function escolher(bookId: string) {
    setSalvando(true);
    try { await habitoApi.escolherLivro(session, { bookId }); onTrocado(); onFechar(); }
    finally { setSalvando(false); }
  }

  // A estante INTEIRA, menos o livro atual. Antes vinha cortada em 12 sem
  // dizer — quem tem mais livros que isso não achava o que procurava e não
  // tinha como saber por quê.
  const daEstante = meusLivros.filter((b) => b.id !== livroAtual?.id);

  return (
    <Sheet open={open} onClose={onFechar} title="Trocar de livro">
      <div style={{ paddingBottom: 14 }}>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--ink-2)', margin: '0 0 14px' }}>
          Largar um livro que não está prendendo é curadoria, não desistência. Sua
          sequência continua exatamente igual — o que este programa acompanha é
          você <i>ler</i>, não terminar este livro específico.
        </p>

        {/* SÓ a estante. Antes esta tela abria em "Sugestões", oferecendo
            livros de um catálogo que a pessoa NÃO TEM — e o protocolo é um
            compromisso de ler amanhã, no mesmo lugar. Indicar um livro que
            ainda precisa ser comprado e esperar entrega é justamente o jeito
            de quebrar a sequência que este programa existe pra proteger.
            Trocar aqui é escolher entre o que já está na mão. */}
        {daEstante.length > 0 && daEstante.map((b) => (
          <button key={b.id} disabled={salvando} onClick={() => escolher(b.id)} style={{
            display: 'flex', gap: 12, width: '100%', textAlign: 'left', padding: 11,
            borderRadius: 16, marginBottom: 8, cursor: 'pointer', alignItems: 'center',
            background: 'var(--paper-2)', border: '1px solid var(--line)',
          }}>
            <BookCover book={b as any} width={38} height={57} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 14.5, color: 'var(--ink)', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.title}</div>
              <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>{b.author}</div>
            </div>
          </button>
        ))}

        {daEstante.length === 0 && (
          <div style={{ fontSize: 13.5, lineHeight: 1.55, color: 'var(--ink-3)', padding: '4px 0 12px' }}>
            Este é o único livro na sua estante. Adicione outro que você já
            tenha em mãos para poder trocar.
          </div>
        )}

        {/* A saída sempre visível: sem ela, quem não tem outro livro cadastrado
            chega numa tela que só sabe dizer não. */}
        {onAdicionarLivro && (
          <button onClick={() => { onFechar(); onAdicionarLivro(); }} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            width: '100%', padding: '13px 16px', borderRadius: 16, marginTop: 4,
            cursor: 'pointer', background: 'transparent',
            border: '1px dashed var(--line-strong)', color: 'var(--ink-2)',
            fontSize: 14, fontFamily: 'inherit',
          }}>
            <Icon name="plus" size={15} color="var(--ink-2)" />
            Adicionar um livro à estante
          </button>
        )}
      </div>
    </Sheet>
  );
};

export default TrocarLivro;
